export default __webpack_public_path__ + "static/media/NIAS0540.34I-40173_-23844_0.c0964c68.jpg";